module.exports = "https://cdn.realtymogul.com/static/media/ExchangeNetLeasedPortfolio26.e05957fc.jpg";